import Print from 'print-js';
export default {
  name: "sheet",
  data: function data() {
    return {
      currentTableData: [],
      loading: false
    };
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    print: function print() {
      Print({
        printable: 'print',
        documentTitle: '函证中心',
        type: 'html',
        // 继承原来的所有样式
        targetStyles: ['*'],
        font_size: '12px'
      });
    }
  }
};